const doc = [({"ja":({"adminConstantHotelWaitingListStatus":({"waiting":"空室待ち", "notified":"通知済み"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;